import { render, staticRenderFns } from "./ResetarSenha.vue?vue&type=template&id=6bc88622"
import script from "./ResetarSenha.vue?vue&type=script&lang=ts"
export * from "./ResetarSenha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports